import { SvgIconProps } from "@mui/material";
import { forwardRef } from "react";

import BellIcon from "./BellIcon";

export default forwardRef<SVGSVGElement, SvgIconProps>(function NotificationsIcon(
  props: SvgIconProps,
  ref,
) {
  return <BellIcon ref={ref} {...props} />;
});
